module.exports = __webpack_public_path__ + "static/media/gamepad.8873ac74.svg";